(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // Scope to the Offers block
    var scope = document.querySelector('.product__section-details__inner--offers_list');
    if (!scope) return;

    // ROW 1: Klaviyo opener
    var klLink = scope.querySelector('.js-offers-klaviyo');
    if (klLink) {
      klLink.addEventListener('click', function (e) {
        e.preventDefault();
        var formId = klLink.getAttribute('data-kl-form');
        window._klOnsite = window._klOnsite || [];
        if (formId) {
          window._klOnsite.push(['openForm', formId]);
        } else {
          console.warn('[Offers] Missing Klaviyo form ID');
        }
      });
    }

    // ROW 2: On-page anchor smooth scroll (if href starts with # and target exists)
    var anchorLink = scope.querySelector('.js-offers-anchor');
    if (anchorLink && anchorLink.getAttribute('href') && anchorLink.getAttribute('href').charAt(0) === '#') {
      anchorLink.addEventListener('click', function (e) {
        var targetId = anchorLink.getAttribute('href').slice(1);
        var targetEl = document.getElementById(targetId);
        if (targetEl) {
          e.preventDefault();
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  });
})();
